module.exports = __webpack_public_path__ + "media/assets/icons/doubleCaretUp-9a7d8ea5223425d12c1397d6cd58980d.svg";